jQuery(function($){
  $(".checkbox").on('click', function() {

    if ($(this).prop('checked')) {
      $('.action_button.add_to_cart').removeClass('gray-button pointer-event');
      $('.action_button.add_to_cart').addClass('pointer-event');
      $('.action_button.add_to_cart').prop('disabled',false);
      $('.main--selector').attr('name','id');
      // console.log(theme.addToCartHtml);
      // $(".purchase-details__buttons").append(theme.addToCartHtml);
      //     $(".purchase-details").css({"width":"auto"});
    } else {
      // alert('is not checked');
      $('.action_button.add_to_cart').addClass('gray-button');
      $('.action_button.add_to_cart').removeClass('pointer-event');
      $('.action_button.add_to_cart').prop('disabled',true);
      $('.main--selector').attr('name','');
      //       var qty_width = $(".product-quantity-box").width();
      //      $(".purchase-details").css({"width":qty_width + 45+'px'});
      //$(".purchase-details__buttons").find(".action_button").remove();
    }
  });

  var modal_width = '860px';
  if($(window).width() >= 1200 || $('html').hasClass('ie')) {
    modal_width = '1080px'
  }
   $("a.fancybox").fancybox({
        width: modal_width,
        height: 'auto',
        autoSize: false,
        padding: [20, 26, 20, 26]
      });
  
    $("a.special-interest-btn ").fancybox({
        width: modal_width,
        height: 'auto',
        autoSize: false,
        padding: [20, 26, 20, 26]
      });
  
  
  
});

// enquire - appointment form

jQuery(function($){
  var info_to_be_sent = $('.product-info-to-be-sent').html();
  $('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent);
//   $('.hidden-product-info').val(''+info_to_be_sent);
  console.log($('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent));
  //console.log($('.appointment_class').find('.hidden-product-info').val(''+info_to_be_sent));
  
  if(window.location.href.indexOf('contact_posted=true') > -1){
    //$('.enquire_now').trigger('click');
    $('.enquire_success').trigger('click');
    var newUrl = window.location.href.replace('?contact_posted=true', '');
    window.history.pushState({path:newUrl},'',newUrl);
  }
});